import {
  ClipboardList,
  CreditCard,
  PlusCircle,
  Search,
  ShieldCheck,
  Truck,
} from "lucide-react";
import { GetList } from "../../types/data-content";

export const getListVirtualStores = () => {
  let list: GetList[] = [
    {
      productId: "#L01",
      platform: "woocommerce",
      titlePage: "Loja Virtual de Roupas em WordPress com WooCommerce",
      titleCard: "Loja Virtual de Roupas em WordPress com WooCommerce",
      nicho: "Moda",
      image: "/assets/loja-virtual/loja-camisetas-mix.jpg",
      link: "http://camisetasmix.com.br/",
      price: "",
      priceSale: "",
      page: "/lojas-virtuais/camisetas-mix",
      filter: "lojas-virtuais",
      cardDescription: `
        Loja virtual completa para gerenciamento de pedidos e produtos de moda. Ideal para loja de roupas, oferecendo controle de estoque, variações de tamanho/cor e vendas online simplificadas.
        <br /><br />
        <strong>Prazo:</strong> de 7 a 15 dias úteis.
      `,
      description: `
        <p>
          Loja virtual com gerenciamento completo, simplifique o cadastro de produtos e a gestão de pedidos, oferecendo uma experiência fácil e intuitiva para você se concentrar no que realmente importa: vender. Com meios de pagamento já integrados, como PagSeguro, Pix e transferência bancária, suas transações são seguras e rápidas.
        </p>
      `,
      video: "",
      planosValues: [
        {
          type: "Invista no Crescimento do Seu Negócio com uma Loja Virtual Profissional 🚀",
          value: "",
          valueInstallments: "Parcelamos em até 12x no cartão de crédito",
          info: `
            <p><strong>Inclui:<strong></p>
            <ul>
              <li>Criação de site ou loja virtual personalizada</li>
              <li>Armazenamento e usuários conforme o plano de hospedagem escolhido.</li>
              <li>Configuração completa na sua plataforma de hospedagem</li>
              <li>Painel administrativo em WordPress (totalmente gerenciável)</li>
              <li>Suporte técnico durante a implementação</li>
              <li>Treinamento básico para gestão do sistema</li>
            </ul>
            <p><strong>Pronto para dar o próximo passo?</strong></p>
            <p>📞 <strong>Entre em contato agora pelo WhatsApp</strong> e agende uma reunião por vídeo!</p>
            <br />
            <a href="https://api.whatsapp.com/send?phone=5511964914546" target="_blank" class="CTA">👉 Vamos conversar</a>
          `,
        },
      ],
      carousel: true,
      imagesCarousel: [
        {
          label: "Configurações do Produto - Listagem",
          imgPath: "/assets/loja-virtual/configuracoes-produto.webp",
        },
        {
          label: "Tela de configurações do produto",
          imgPath: "/assets/loja-virtual/tela-produtos.webp",
        },
        {
          label: "Tela de categorias do produto",
          imgPath: "/assets/loja-virtual/tela-categorias-produto.webp",
        },
        {
          label: "Tela de pedidos",
          imgPath: "/assets/loja-virtual/tela-pedidos.webp",
        },
        {
          label: "Tela de detalhes do pedido",
          imgPath: "/assets/loja-virtual/detalhes-pedido.webp",
        },
        {
          label: "Tela de configurações gerais",
          imgPath: "/assets/loja-virtual/tela-configuracoes-geral.webp",
        },
        {
          label: "Tela de clientes",
          imgPath: "/assets/loja-virtual/tela-clientes.webp",
        },
        {
          label: "Tela de configurações de meios de pagamento",
          imgPath: "/assets/loja-virtual/tela-pagamentos.webp",
        },
        {
          label: "Tela de relatórios",
          imgPath: "/assets/loja-virtual/tela-relatorios.webp",
        },
        {
          label: "Tela de formulários",
          imgPath: "/assets/loja-virtual/formulario-newsletter.webp",
        },
        {
          label: "Email newsletter",
          imgPath: "/assets/loja-virtual/email-newsletter.webp",
        },
      ],
      formulario: "",
      features: [
        {
          icon: <PlusCircle className="w-8 h-8 text-primary" />,
          title: "Cadastro Fácil",
          description:
            "Adicione novos produtos com apenas alguns cliques, sem complicações.",
        },
        {
          icon: <ClipboardList className="w-8 h-8 text-primary" />,
          title: "Gestão Simplificada",
          description:
            "Controle seus pedidos de forma eficiente e acompanhe o desempenho da loja.",
        },
        {
          icon: <CreditCard className="w-8 h-8 text-primary" />,
          title: "Pagamentos Integrados",
          description:
            "Ofereça aos seus clientes as opções de pagamento mais populares, como Pix, cartão e transferência.",
        },
        {
          icon: <Truck className="w-8 h-8 text-primary" />,
          title: "Controle de Entregas",
          description:
            "Acompanhe o status de envio de cada pedido e informe seus clientes em tempo real.",
        },
        {
          icon: <Search className="w-8 h-8 text-primary" />,
          title: "Busca e Filtros",
          description:
            "Facilite a navegação de clientes com filtros por categoria, preço e disponibilidade.",
        },
        {
          icon: <ShieldCheck className="w-8 h-8 text-primary" />,
          title: "Segurança e Confiabilidade",
          description:
            "Transações seguras e proteção de dados para clientes e lojista.",
        },
      ],
      includedFeatures: [
        "Loja virtual pronta para uso, totalmente funcional",
        "Cadastro rápido e intuitivo de produtos",
        "Gestão completa de pedidos e estoque",
        "Pagamentos integrados via Pix, cartão e transferência bancária",
        "Controle de entregas e acompanhamento em tempo real",
        "Layout moderno, responsivo e personalizável",
      ],
      beneficiosDescription: `
               Gerencie sua loja virtual de forma simples e eficiente: cadastre produtos rapidamente, controle pedidos com facilidade e ofereça pagamentos seguros e integrados para seus clientes.
            `,
    },
    {
      productId: "#L02",
      platform: "woocommerce",
      titlePage:
        "Loja Virtual de Produtos de Tecnologia em WordPress com WooCommerce",
      titleCard:
        "Loja Virtual de Produtos de Tecnologia em WordPress com WooCommerce",
      nicho: "Tecnologia",
      image: "/assets/loja-virtual/loja-shop-tecnologia.jpg",
      link: "https://shoptecnologia.com.br/",
      price: "",
      priceSale: "",
      exibirFidelidade: true,
      cardDescription: `
        Loja virtual completa para gerenciamento de pedidos e produtos de tecnologia. Controle de estoque, categorias de produtos e vendas online.
        <br /><br />
        <strong>Prazo:</strong> de 7 a 15 dias úteis.
      `,
      description: `
        <p>
        Loja virtual com gerenciamento completo, simplifique o cadastro de produtos e a gestão de pedidos, oferecendo uma experiência fácil e intuitiva para você se concentrar no que realmente importa: vender. Com meios de pagamento já integrados, como PagSeguro, Pix e transferência bancária, suas transações são seguras e rápidas.
        </p>
      `,
      video: "",
      planosValues: [
        {
          type: "Invista no Crescimento do Seu Negócio com uma Loja Virtual Profissional 🚀",
          value: "",
          valueInstallments: "Parcelamos até 12x no cartão de crédito",
          info: `
            <p><strong>Inclui:<strong></p>
            <ul>
              <li>Criação de site ou loja virtual personalizada</li>
              <li>Armazenamento e usuários conforme o plano de hospedagem escolhido.</li>
              <li>Configuração completa na sua plataforma de hospedagem</li>
              <li>Painel administrativo em WordPress (totalmente gerenciável)</li>
              <li>Suporte técnico durante a implementação</li>
              <li>Treinamento básico para gestão do sistema</li>
            </ul>
            <p><strong>Pronto para dar o próximo passo?</strong></p>
            <p>📞 <strong>Entre em contato agora pelo WhatsApp</strong> e agende uma reunião por vídeo!</p>
            <br />
            <a href="https://api.whatsapp.com/send?phone=5511964914546" target="_blank" class="CTA">👉 Vamos conversar</a>

          `,
        },
      ],
      page: "/lojas-virtuais/shop-tecnologia",
      filter: "lojas-virtuais",
      carousel: true,
      imagesCarousel: [
        {
          label: "Configurações do Produto - Listagem",
          imgPath: "/assets/loja-virtual/configuracoes-produto.webp",
        },
        {
          label: "Tela de configurações do produto",
          imgPath: "/assets/loja-virtual/tela-produtos.webp",
        },
        {
          label: "Tela de categorias do produto",
          imgPath: "/assets/loja-virtual/tela-categorias-produto.webp",
        },
        {
          label: "Tela de pedidos",
          imgPath: "/assets/loja-virtual/tela-pedidos.webp",
        },
        {
          label: "Tela de detalhes do pedido",
          imgPath: "/assets/loja-virtual/detalhes-pedido.webp",
        },
        {
          label: "Tela de configurações gerais",
          imgPath: "/assets/loja-virtual/tela-configuracoes-geral.webp",
        },
        {
          label: "Tela de clientes",
          imgPath: "/assets/loja-virtual/tela-clientes.webp",
        },
        {
          label: "Tela de configurações de meios de pagamento",
          imgPath: "/assets/loja-virtual/tela-pagamentos.webp",
        },
        {
          label: "Tela de relatórios",
          imgPath: "/assets/loja-virtual/tela-relatorios.webp",
        },
        {
          label: "Tela de formulários",
          imgPath: "/assets/loja-virtual/formulario-newsletter.webp",
        },
        {
          label: "Email newsletter",
          imgPath: "/assets/loja-virtual/email-newsletter.webp",
        },
      ],
      formulario: "",
      features: [
        {
          icon: <PlusCircle className="w-8 h-8 text-primary" />,
          title: "Cadastro Fácil",
          description:
            "Adicione novos produtos com apenas alguns cliques, sem complicações.",
        },
        {
          icon: <ClipboardList className="w-8 h-8 text-primary" />,
          title: "Gestão Simplificada",
          description:
            "Controle seus pedidos de forma eficiente e acompanhe o desempenho da loja.",
        },
        {
          icon: <CreditCard className="w-8 h-8 text-primary" />,
          title: "Pagamentos Integrados",
          description:
            "Ofereça aos seus clientes as opções de pagamento mais populares, como Pix, cartão e transferência.",
        },
        {
          icon: <Truck className="w-8 h-8 text-primary" />,
          title: "Controle de Entregas",
          description:
            "Acompanhe o status de envio de cada pedido e informe seus clientes em tempo real.",
        },
        {
          icon: <Search className="w-8 h-8 text-primary" />,
          title: "Busca e Filtros",
          description:
            "Facilite a navegação de clientes com filtros por categoria, preço e disponibilidade.",
        },
        {
          icon: <ShieldCheck className="w-8 h-8 text-primary" />,
          title: "Segurança e Confiabilidade",
          description:
            "Transações seguras e proteção de dados para clientes e lojista.",
        },
      ],
      includedFeatures: [
        "Loja virtual pronta para uso, totalmente funcional",
        "Cadastro rápido e intuitivo de produtos",
        "Gestão completa de pedidos e estoque",
        "Pagamentos integrados via Pix, cartão e transferência bancária",
        "Controle de entregas e acompanhamento em tempo real",
        "Layout moderno, responsivo e personalizável",
      ],
      beneficiosDescription: `
               Gerencie sua loja virtual de forma simples e eficiente: cadastre produtos rapidamente, controle pedidos com facilidade e ofereça pagamentos seguros e integrados para seus clientes.
            `,
    },
    {
      productId: "#L03",
      platform: "woocommerce",
      titlePage:
        "Loja Virtual de Moda, Calçados e Acessórios em WordPress com WooCommerce",
      titleCard:
        "Loja Virtual de Moda, Calçados e Acessórios em WordPress com WooCommerce",
      nicho: "Moda",
      image: "/assets/loja-virtual/adamiche-modas.jpg",
      link: "https://adamichemodas.com.br/",
      caseBadge: "Projeto Real / Cliente",
      clientName: "Adamiche Modas",
      caseCtaLabel: "Visitar Loja",
      caseDemoCtaLabel: "Visitar Loja",
      price: "",
      priceSale: "",
      exibirFidelidade: false,
      cardDescription: `
        <strong>Case real: Adamiche Modas.</strong> Cliente com loja fisica iniciando no digital, com foco em vender moda, calcados e acessorios online com operacao simples e profissional.
        <br /><br />
        <strong>Prazo:</strong> de 7 a 15 dias úteis.
      `,
      description: `
        <p>
          <strong>Desafio:</strong> a Adamiche Modas ja tinha operacao em loja fisica e precisava iniciar no digital sem complicar a rotina, com catalogo organizado e processo de venda online confiavel.
        </p>
        <br />
        <p>
          <strong>O que fizemos:</strong> desenvolvemos a loja virtual em <strong>WordPress com WooCommerce</strong>, estruturando categorias de moda, calcados e acessorios, cadastro de produtos com variacoes e fluxo de pedidos para facilitar a operacao no dia a dia.
        </p>
        <br />
        <p>
          <strong>Diferencial técnico:</strong> configuracao completa de checkout e pagamentos (pix, cartao e transferencia), painel administrativo gerenciavel e base pronta para escalar o canal digital junto com a loja fisica.
        </p>
      `,
      video: "",
      planosValues: [
        {
          type: "Invista no Crescimento do Seu Negócio com uma Loja Virtual Profissional 🚀",
          value: "",
          valueInstallments: "Parcelamos até 12x no cartão de crédito",
          info: `
            <p><strong>Inclui:<strong></p>
            <ul>
              <li>Criação de site ou loja virtual personalizada</li>
              <li>Armazenamento e usuários conforme o plano de hospedagem escolhido.</li>
              <li>Configuração completa na sua plataforma de hospedagem</li>
              <li>Painel administrativo em WordPress (totalmente gerenciável)</li>
              <li>Suporte técnico durante a implementação</li>
              <li>Treinamento básico para gestão do sistema</li>
            </ul>
            <p><strong>Pronto para dar o próximo passo?</strong></p>
            <p>📞 <strong>Entre em contato agora pelo WhatsApp</strong> e agende uma reunião por vídeo!</p>
            <br />
            <a href="https://api.whatsapp.com/send?phone=5511964914546" target="_blank" class="CTA">👉 Vamos conversar</a>

          `,
        },
      ],
      page: "/lojas-virtuais/adamiche-modas",
      filter: "lojas-virtuais",
      carousel: true,
      imagesCarousel: [
        {
          label: "Configurações do Produto - Listagem",
          imgPath: "/assets/loja-virtual/configuracoes-produto.webp",
        },
        {
          label: "Tela de configurações do produto",
          imgPath: "/assets/loja-virtual/tela-produtos.webp",
        },
        {
          label: "Tela de categorias do produto",
          imgPath: "/assets/loja-virtual/tela-categorias-produto.webp",
        },
        {
          label: "Tela de pedidos",
          imgPath: "/assets/loja-virtual/tela-pedidos.webp",
        },
        {
          label: "Tela de detalhes do pedido",
          imgPath: "/assets/loja-virtual/detalhes-pedido.webp",
        },
        {
          label: "Tela de configurações gerais",
          imgPath: "/assets/loja-virtual/tela-configuracoes-geral.webp",
        },
        {
          label: "Tela de clientes",
          imgPath: "/assets/loja-virtual/tela-clientes.webp",
        },
        {
          label: "Tela de configurações de meios de pagamento",
          imgPath: "/assets/loja-virtual/tela-pagamentos.webp",
        },
        {
          label: "Tela de relatórios",
          imgPath: "/assets/loja-virtual/tela-relatorios.webp",
        },
        {
          label: "Tela de formulários",
          imgPath: "/assets/loja-virtual/formulario-newsletter.webp",
        },
        {
          label: "Email newsletter",
          imgPath: "/assets/loja-virtual/email-newsletter.webp",
        },
      ],
      formulario: "",
      features: [
        {
          icon: <PlusCircle className="w-8 h-8 text-primary" />,
          title: "Cadastro Fácil",
          description:
            "Adicione novos produtos com apenas alguns cliques, sem complicações.",
        },
        {
          icon: <ClipboardList className="w-8 h-8 text-primary" />,
          title: "Gestão Simplificada",
          description:
            "Controle seus pedidos de forma eficiente e acompanhe o desempenho da loja.",
        },
        {
          icon: <CreditCard className="w-8 h-8 text-primary" />,
          title: "Pagamentos Integrados",
          description:
            "Ofereça aos seus clientes as opções de pagamento mais populares, como pix, cartão e transferência.",
        },
        {
          icon: <Truck className="w-8 h-8 text-primary" />,
          title: "Controle de Entregas",
          description:
            "Acompanhe o status de envio de cada pedido e informe seus clientes em tempo real.",
        },
        {
          icon: <Search className="w-8 h-8 text-primary" />,
          title: "Busca e Filtros",
          description:
            "Facilite a navegação de clientes com filtros por categoria, preço e disponibilidade.",
        },
        {
          icon: <ShieldCheck className="w-8 h-8 text-primary" />,
          title: "Segurança e Confiabilidade",
          description:
            "Transações seguras e proteção de dados para clientes e lojista.",
        },
      ],
      includedFeatures: [
        "Loja virtual pronta para uso, totalmente funcional",
        "Cadastro rápido e intuitivo de produtos",
        "Gestão completa de pedidos e estoque",
        "Pagamentos integrados via pix, cartão e transferência bancária",
        "Controle de entregas e acompanhamento em tempo real",
        "Layout moderno, responsivo e personalizável",
      ],
      beneficiosDescription: `
               Gerencie sua loja virtual de forma simples e eficiente: cadastre produtos rapidamente, controle pedidos com facilidade e ofereça pagamentos seguros e integrados para seus clientes.
            `,
    },
    {
      productId: "#L05",
      platform: "woocommerce",
      titlePage:
        "Loja Virtual para venda de carnes nobres em WordPress com WooCommerce",
      titleCard:
        "Loja Virtual para venda de carnes nobres em WordPress com WooCommerce",
      nicho: "Alimentação",
      image: "/assets/loja-virtual/sabor-dos-deuses.webp",
      link: "https://lightblue-cormorant-904301.hostingersite.com/",
      price: "",
      priceSale: "",
      exibirFidelidade: false,
      cardDescription: `
        Loja virtual completa para gerenciamento de pedidos e produtos. Variação por kg ou unidade, ideal para açougues e venda de carnes nobres.
        <br /><br />
        <strong>Prazo:</strong> de 7 a 15 dias úteis.
      `,
      description: `
        <p>
        Loja virtual com gerenciamento completo, simplifique o cadastro de produtos e a gestão de pedidos, oferecendo uma experiência fácil e intuitiva para você se concentrar no que realmente importa: vender. Com meios de pagamento já integrados, como mercado pago, pix e transferência bancária, suas transações são seguras e rápidas.
        </p>
      `,
      video: "",
      planosValues: [
        {
          type: "Invista no Crescimento do Seu Negócio com uma Loja Virtual Profissional 🚀",
          value: "",
          valueInstallments: "Parcelamos até 12x no cartão de crédito",
          info: `
            <p><strong>Inclui:<strong></p>
            <ul>
              <li>Criação de site ou loja virtual personalizada</li>
              <li>Armazenamento e usuários conforme o plano de hospedagem escolhido.</li>
              <li>Configuração completa na sua plataforma de hospedagem</li>
              <li>Painel administrativo em WordPress (totalmente gerenciável)</li>
              <li>Suporte técnico durante a implementação</li>
              <li>Treinamento básico para gestão do sistema</li>
            </ul>
            <p><strong>Pronto para dar o próximo passo?</strong></p>
            <p>📞 <strong>Entre em contato agora pelo WhatsApp</strong> e agende uma reunião por vídeo!</p>
            <br />
            <a href="https://api.whatsapp.com/send?phone=5511964914546" target="_blank" class="CTA">👉 Vamos conversar</a>

          `,
        },
      ],
      page: "/lojas-virtuais/sabor-dos-deuses",
      filter: "lojas-virtuais",
      carousel: true,
      imagesCarousel: [
        {
          label: "Configurações do Produto - Listagem",
          imgPath: "/assets/loja-virtual/configuracoes-produto.webp",
        },
        {
          label: "Tela de configurações do produto",
          imgPath: "/assets/loja-virtual/tela-produtos.webp",
        },
        {
          label: "Tela de categorias do produto",
          imgPath: "/assets/loja-virtual/tela-categorias-produto.webp",
        },
        {
          label: "Tela de pedidos",
          imgPath: "/assets/loja-virtual/tela-pedidos.webp",
        },
        {
          label: "Tela de detalhes do pedido",
          imgPath: "/assets/loja-virtual/detalhes-pedido.webp",
        },
        {
          label: "Tela de configurações gerais",
          imgPath: "/assets/loja-virtual/tela-configuracoes-geral.webp",
        },
        {
          label: "Tela de clientes",
          imgPath: "/assets/loja-virtual/tela-clientes.webp",
        },
        {
          label: "Tela de configurações de meios de pagamento",
          imgPath: "/assets/loja-virtual/tela-pagamentos.webp",
        },
        {
          label: "Tela de relatórios",
          imgPath: "/assets/loja-virtual/tela-relatorios.webp",
        },
        {
          label: "Tela de formulários",
          imgPath: "/assets/loja-virtual/formulario-newsletter.webp",
        },
        {
          label: "Email newsletter",
          imgPath: "/assets/loja-virtual/email-newsletter.webp",
        },
      ],
      formulario: "",
      features: [
        {
          icon: <PlusCircle className="w-8 h-8 text-primary" />,
          title: "Cadastro Fácil",
          description:
            "Adicione novos produtos com apenas alguns cliques, sem complicações.",
        },
        {
          icon: <ClipboardList className="w-8 h-8 text-primary" />,
          title: "Gestão Simplificada",
          description:
            "Controle seus pedidos de forma eficiente e acompanhe o desempenho da loja.",
        },
        {
          icon: <CreditCard className="w-8 h-8 text-primary" />,
          title: "Pagamentos Integrados",
          description:
            "Ofereça aos seus clientes as opções de pagamento mais populares, como pix, cartão e transferência.",
        },
        {
          icon: <Truck className="w-8 h-8 text-primary" />,
          title: "Controle de Entregas",
          description:
            "Acompanhe o status de envio de cada pedido e informe seus clientes em tempo real.",
        },
        {
          icon: <Search className="w-8 h-8 text-primary" />,
          title: "Busca e Filtros",
          description:
            "Facilite a navegação de clientes com filtros por categoria, preço e disponibilidade.",
        },
        {
          icon: <ShieldCheck className="w-8 h-8 text-primary" />,
          title: "Segurança e Confiabilidade",
          description:
            "Transações seguras e proteção de dados para clientes e lojista.",
        },
      ],
      includedFeatures: [
        "Loja virtual pronta para uso, totalmente funcional",
        "Cadastro rápido e intuitivo de produtos",
        "Gestão completa de pedidos e estoque",
        "Pagamentos integrados via pix, cartão e transferência bancária",
        "Controle de entregas e acompanhamento em tempo real",
        "Layout moderno, responsivo e personalizável",
      ],
      beneficiosDescription: `
               Gerencie sua loja virtual de forma simples e eficiente: cadastre produtos rapidamente, controle pedidos com facilidade e ofereça pagamentos seguros e integrados para seus clientes.
            `,
    },
    {
      productId: "#L06",
      platform: "nuvemshop",
      titlePage:
        "Loja Virtual na Nuvemshop do nicho de Cama, Mesa, Banho, Tapetes, Decoração, Cortinas",
      titleCard:
        "Loja Virtual na Nuvemshop do nicho de Cama, Mesa, Banho, Tapetes, Decoração, Cortinas",
      nicho: "Casa & Decoração",
      image: "/assets/loja-virtual/casa-spack.webp",
      link: "https://casaspack.com.br/",
      caseBadge: "Projeto Real / Cliente",
      clientName: "Casa Spack",
      caseCtaLabel: "Visitar Loja",
      caseDemoCtaLabel: "Visitar Loja",
      price: "",
      priceSale: "",
      exibirFidelidade: false,
      cardDescription: `
        <strong>Case real: Casa Spack.</strong> O desafio era organizar um catálogo amplo de casa e decoração com navegação clara e checkout simples. Estruturamos a loja na <strong>Nuvemshop</strong>, com arquitetura por categorias, filtros e fluxo de compra otimizado para conversão.
        <br /><br />
        <strong>Prazo:</strong> de 7 a 15 dias úteis.
      `,
      description: `
        <p>
          <strong>Desafio:</strong> a Casa Spack precisava de um e-commerce robusto para vender cama, mesa, banho, tapetes, decoração e cortinas com uma experiência de navegação fluida, mesmo com muitos SKUs e variações.
        </p>
        <br />
        <p>
          <strong>O que fizemos:</strong> desenvolvemos a loja na plataforma <strong>Nuvemshop</strong>, organizando o catálogo por categorias estratégicas, configurando páginas de produto com informações objetivas e estruturando um checkout mais direto para reduzir abandono.
        </p>
        <br />
        <p>
          <strong>Diferencial técnico:</strong> modelagem de navegação e filtros pensando em performance comercial, integrações de pagamento (pix, cartão e transferência) e configuração operacional para gestão contínua de pedidos e estoque sem complexidade.
        </p>
      `,
      video: "",
      planosValues: [
        {
          type: "Invista no Crescimento do Seu Negócio com uma Loja Virtual Profissional 🚀",
          value: "",
          valueInstallments: "Parcelamos até 12x no cartão de crédito",
          info: `
            <p><strong>Inclui:<strong></p>
            <ul>
              <li>Criação de site ou loja virtual personalizada</li>
              <li>Armazenamento e usuários conforme o plano de hospedagem escolhido.</li>
              <li>Configuração completa na sua plataforma de hospedagem</li>
              <li>Painel administrativo em WordPress (totalmente gerenciável)</li>
              <li>Suporte técnico durante a implementação</li>
              <li>Treinamento básico para gestão do sistema</li>
            </ul>
            <p><strong>Pronto para dar o próximo passo?</strong></p>
            <p>📞 <strong>Entre em contato agora pelo WhatsApp</strong> e agende uma reunião por vídeo!</p>
            <br />
            <a href="https://api.whatsapp.com/send?phone=5511964914546" target="_blank" class="CTA">👉 Vamos conversar</a>

          `,
        },
      ],
      page: "/lojas-virtuais/casas-pack",
      filter: "lojas-virtuais",
      carousel: false,
      imagesCarousel: [
        {
          label: "Configurações do Produto - Listagem",
          imgPath: "/assets/loja-virtual/configuracoes-produto.webp",
        },
        {
          label: "Tela de configurações do produto",
          imgPath: "/assets/loja-virtual/tela-produtos.webp",
        },
        {
          label: "Tela de categorias do produto",
          imgPath: "/assets/loja-virtual/tela-categorias-produto.webp",
        },
        {
          label: "Tela de pedidos",
          imgPath: "/assets/loja-virtual/tela-pedidos.webp",
        },
        {
          label: "Tela de detalhes do pedido",
          imgPath: "/assets/loja-virtual/detalhes-pedido.webp",
        },
        {
          label: "Tela de configurações gerais",
          imgPath: "/assets/loja-virtual/tela-configuracoes-geral.webp",
        },
        {
          label: "Tela de clientes",
          imgPath: "/assets/loja-virtual/tela-clientes.webp",
        },
        {
          label: "Tela de configurações de meios de pagamento",
          imgPath: "/assets/loja-virtual/tela-pagamentos.webp",
        },
        {
          label: "Tela de relatórios",
          imgPath: "/assets/loja-virtual/tela-relatorios.webp",
        },
        {
          label: "Tela de formulários",
          imgPath: "/assets/loja-virtual/formulario-newsletter.webp",
        },
        {
          label: "Email newsletter",
          imgPath: "/assets/loja-virtual/email-newsletter.webp",
        },
      ],
      formulario: "",
      features: [
        {
          icon: <PlusCircle className="w-8 h-8 text-primary" />,
          title: "Cadastro Fácil",
          description:
            "Adicione novos produtos com apenas alguns cliques, sem complicações.",
        },
        {
          icon: <ClipboardList className="w-8 h-8 text-primary" />,
          title: "Gestão Simplificada",
          description:
            "Controle seus pedidos de forma eficiente e acompanhe o desempenho da loja.",
        },
        {
          icon: <CreditCard className="w-8 h-8 text-primary" />,
          title: "Pagamentos Integrados",
          description:
            "Ofereça aos seus clientes as opções de pagamento mais populares, como pix, cartão e transferência.",
        },
        {
          icon: <Truck className="w-8 h-8 text-primary" />,
          title: "Controle de Entregas",
          description:
            "Acompanhe o status de envio de cada pedido e informe seus clientes em tempo real.",
        },
        {
          icon: <Search className="w-8 h-8 text-primary" />,
          title: "Busca e Filtros",
          description:
            "Facilite a navegação de clientes com filtros por categoria, preço e disponibilidade.",
        },
        {
          icon: <ShieldCheck className="w-8 h-8 text-primary" />,
          title: "Segurança e Confiabilidade",
          description:
            "Transações seguras e proteção de dados para clientes e lojista.",
        },
      ],
      includedFeatures: [
        "Loja virtual pronta para uso, totalmente funcional",
        "Cadastro rápido e intuitivo de produtos",
        "Gestão completa de pedidos e estoque",
        "Pagamentos integrados via pix, cartão e transferência bancária",
        "Controle de entregas e acompanhamento em tempo real",
        "Layout moderno, responsivo e personalizável",
      ],
      beneficiosDescription: `
               Gerencie sua loja virtual de forma simples e eficiente: cadastre produtos rapidamente, controle pedidos com facilidade e ofereça pagamentos seguros e integrados para seus clientes.
            `,
    },
    {
      productId: "#L07",
      platform: "shopify",
      titlePage:
        "Loja Virtual na Shopify de Papelaria Artesanal e Produtos Personalizados",
      titleCard:
        "Loja Virtual na Shopify de Papelaria Artesanal e Produtos Personalizados",
      nicho: "Papelaria Personalizada",
      image: "/assets/loja-virtual/bianca-faust.webp",
      link: "https://biancafaust.com.br/",
      caseBadge: "Projeto Real / Cliente",
      clientName: "Bianca Faust",
      caseCtaLabel: "Visitar Loja",
      caseDemoCtaLabel: "Visitar Loja",
      price: "",
      priceSale: "",
      exibirFidelidade: false,
      cardDescription: `
        <strong>Case real: Bianca Faust.</strong> O desafio era vender produtos personalizados com uma jornada simples para o cliente montar cada peça. Desenvolvemos uma loja na <strong>Shopify</strong> com fluxo guiado de personalização e operação preparada para pedidos sob medida.
        <br /><br />
        <strong>Prazo:</strong> de 7 a 15 dias úteis.
      `,
      description: `
        <p>
          <strong>Desafio:</strong> a Bianca Faust precisava transformar um catálogo artesanal em uma experiência digital premium, sem perder o cuidado da personalização em cada produto.
        </p>
        <br />
        <p>
          <strong>O que fizemos:</strong> criamos a loja na plataforma <strong>Shopify</strong> com foco em papelaria personalizada (cadernos, cartões, planners e tags), estruturando a jornada para o cliente configurar sua peça com clareza antes de concluir o pedido.
        </p>
        <br />
        <p>
          <strong>Diferencial técnico:</strong> implementação de <strong>produto personalizado por etapas</strong>, com montagem guiada (couro, miolo, gravação e acabamentos), integrando pagamentos (pix, cartão e boleto) e fluxo operacional para gestão confiável de pedidos customizados.
        </p>
      `,
      video: "",
      planosValues: [
        {
          type: "Invista no Crescimento do Seu Negócio com uma Loja Virtual Profissional 🚀",
          value: "",
          valueInstallments: "Parcelamos até 12x no cartão de crédito",
          info: `
            <p><strong>Inclui:</strong></p>
            <ul>
              <li>Criação de loja virtual personalizada na Shopify</li>
              <li>Configuração de produto personalizado por etapas (montagem guiada da peça pelo cliente)</li>
              <li>Recursos e usuários conforme o plano Shopify escolhido.</li>
              <li>Configuração completa da loja na plataforma Shopify</li>
              <li>Painel administrativo Shopify (totalmente gerenciável)</li>
              <li>Suporte técnico durante a implementação</li>
              <li>Treinamento básico para gestão da loja</li>
            </ul>
            <p><strong>Pronto para dar o próximo passo?</strong></p>
            <p>📞 <strong>Entre em contato agora pelo WhatsApp</strong> e agende uma reunião por vídeo!</p>
            <br />
            <a href="https://api.whatsapp.com/send?phone=5511964914546" target="_blank" class="CTA">👉 Vamos conversar</a>

          `,
        },
      ],
      page: "/lojas-virtuais/bianca-faust",
      filter: "lojas-virtuais",
      carousel: false,
      imagesCarousel: [
        {
          label: "Configurações do Produto - Listagem",
          imgPath: "/assets/loja-virtual/configuracoes-produto.webp",
        },
        {
          label: "Tela de configurações do produto",
          imgPath: "/assets/loja-virtual/tela-produtos.webp",
        },
        {
          label: "Tela de categorias do produto",
          imgPath: "/assets/loja-virtual/tela-categorias-produto.webp",
        },
        {
          label: "Tela de pedidos",
          imgPath: "/assets/loja-virtual/tela-pedidos.webp",
        },
        {
          label: "Tela de detalhes do pedido",
          imgPath: "/assets/loja-virtual/detalhes-pedido.webp",
        },
        {
          label: "Tela de configurações gerais",
          imgPath: "/assets/loja-virtual/tela-configuracoes-geral.webp",
        },
        {
          label: "Tela de clientes",
          imgPath: "/assets/loja-virtual/tela-clientes.webp",
        },
        {
          label: "Tela de configurações de meios de pagamento",
          imgPath: "/assets/loja-virtual/tela-pagamentos.webp",
        },
        {
          label: "Tela de relatórios",
          imgPath: "/assets/loja-virtual/tela-relatorios.webp",
        },
        {
          label: "Tela de formulários",
          imgPath: "/assets/loja-virtual/formulario-newsletter.webp",
        },
        {
          label: "Email newsletter",
          imgPath: "/assets/loja-virtual/email-newsletter.webp",
        },
      ],
      formulario: "",
      features: [
        {
          icon: <PlusCircle className="w-8 h-8 text-primary" />,
          title: "Cadastro Fácil",
          description:
            "Adicione novos produtos com apenas alguns cliques, sem complicações.",
        },
        {
          icon: <ClipboardList className="w-8 h-8 text-primary" />,
          title: "Gestão Simplificada",
          description:
            "Controle seus pedidos de forma eficiente e acompanhe o desempenho da loja.",
        },
        {
          icon: <CreditCard className="w-8 h-8 text-primary" />,
          title: "Pagamentos Integrados",
          description:
            "Ofereça aos seus clientes as opções de pagamento mais populares, como pix, cartão e transferência.",
        },
        {
          icon: <Truck className="w-8 h-8 text-primary" />,
          title: "Controle de Entregas",
          description:
            "Acompanhe o status de envio de cada pedido e informe seus clientes em tempo real.",
        },
        {
          icon: <Search className="w-8 h-8 text-primary" />,
          title: "Busca e Filtros",
          description:
            "Facilite a navegação de clientes com filtros por categoria, preço e disponibilidade.",
        },
        {
          icon: <ShieldCheck className="w-8 h-8 text-primary" />,
          title: "Segurança e Confiabilidade",
          description:
            "Transações seguras e proteção de dados para clientes e lojista.",
        },
      ],
      includedFeatures: [
        "Loja virtual pronta para uso, totalmente funcional",
        "Cadastro rápido e intuitivo de produtos",
        "Gestão completa de pedidos e estoque",
        "Pagamentos integrados via pix, cartão e transferência bancária",
        "Controle de entregas e acompanhamento em tempo real",
        "Layout moderno, responsivo e personalizável",
      ],
      beneficiosDescription: `
               Gerencie sua loja virtual de forma simples e eficiente: cadastre produtos rapidamente, controle pedidos com facilidade e ofereça pagamentos seguros e integrados para seus clientes.
            `,
    },
    {
      productId: "#L08",
      platform: "nuvemshop",
      titlePage:
        "Loja Virtual na Nuvemshop de Semijoias, Pratas, Relógios e Acessórios",
      titleCard:
        "Loja Virtual na Nuvemshop de Semijoias, Pratas, Relógios e Acessórios",
      nicho: "Semijoias & Acessórios",
      image: "/assets/loja-virtual/rizzy-collection.webp",
      link: "https://www.rizzycollection.com.br/",
      caseBadge: "Projeto Real / Cliente",
      clientName: "Rizzy Collection",
      caseCtaLabel: "Visitar Loja",
      caseDemoCtaLabel: "Visitar Loja",
      price: "",
      priceSale: "",
      exibirFidelidade: false,
      cardDescription: `
        <strong>Case real: Rizzy Collection.</strong> A cliente vendia semijoias de porta em porta e precisava dar o primeiro passo no digital. Criamos a loja na <strong>Nuvemshop</strong> com domínio próprio, catálogo organizado por categorias e canais integrados (Instagram e WhatsApp) para vender sem depender do atendimento presencial.
        <br /><br />
        <strong>Prazo:</strong> de 7 a 15 dias úteis.
      `,
      description: `
        <p>
          <strong>Desafio:</strong> a Rizzy Collection trabalhava com venda direta, de porta em porta, e estava iniciando no digital. Era preciso transformar um mix de semijoias, pratas, relógios e acessórios em uma vitrine online própria com endereço fiável, apresentação profissional e um caminho de compra que a cliente pudesse operar sozinha no dia a dia.
        </p>
        <br />
        <p>
          <strong>O que fizemos:</strong> desenvolvemos a loja na plataforma <strong>Nuvemshop</strong> com layout construído a partir da identidade da marca, estruturando o catálogo em categorias e subcategorias (semijoias, pratas, relógios e acessórios) para que o crescimento do estoque não bagunçasse a navegação. Configuramos a home com seções estratégicas de conteúdo, feed do Instagram e botão flutuante de WhatsApp, além das páginas institucionais (Sobre Nós, Política de Privacidade, Termos e Condições, Trocas e Devoluções, Prazos e Envios) e de todo o fluxo de compra: categoria, produto, busca, carrinho, checkout, minha conta e pedido confirmado.
        </p>
        <br />
        <p>
          <strong>Diferencial técnico:</strong> registro e configuração do <strong>domínio próprio</strong> (rizzycollection.com.br) apontado para a Nuvemshop, cadastro do <strong>Perfil de Empresa no Google</strong> para a marca aparecer nas buscas locais e preparação da operação para os próximos passos de crescimento para o Google Shopping, campanha de pesquisa no Google Ads e carrossel de avaliações reais na página inicial.
        </p>
      `,
      video: "",
      planosValues: [
        {
          type: "Invista no Crescimento do Seu Negócio com uma Loja Virtual Profissional 🚀",
          value: "",
          valueInstallments: "Parcelamos até 12x no cartão de crédito",
          info: `
            <p><strong>Inclui:</strong></p>
            <ul>
              <li>Criação de loja virtual personalizada na Nuvemshop</li>
              <li>Catálogo estruturado por categorias e subcategorias (semijoias, pratas, relógios e acessórios)</li>
              <li>Home com seções estratégicas, feed do Instagram e botão flutuante de WhatsApp</li>
              <li>Páginas institucionais completas (Sobre Nós, Política de Privacidade, Termos e Condições, Trocas e Devoluções, Prazos e Envios)</li>
              <li>Registro e configuração de domínio próprio</li>
              <li>Cadastro do Perfil de Empresa no Google</li>
              <li>Recursos e usuários conforme o plano Nuvemshop escolhido.</li>
              <li>Painel administrativo Nuvemshop (totalmente gerenciável)</li>
              <li>Suporte técnico durante a implementação</li>
              <li>Treinamento básico para gestão da loja</li>
            </ul>
            <p><strong>Pronto para dar o próximo passo?</strong></p>
            <p>📞 <strong>Entre em contato agora pelo WhatsApp</strong> e agende uma reunião por vídeo!</p>
            <br />
            <a href="https://api.whatsapp.com/send?phone=5511964914546" target="_blank" class="CTA">👉 Vamos conversar</a>

          `,
        },
      ],
      page: "/lojas-virtuais/rizzy-collection",
      filter: "lojas-virtuais",
      carousel: false,
      imagesCarousel: [
        {
          label: "Configurações do Produto - Listagem",
          imgPath: "/assets/loja-virtual/configuracoes-produto.webp",
        },
        {
          label: "Tela de configurações do produto",
          imgPath: "/assets/loja-virtual/tela-produtos.webp",
        },
        {
          label: "Tela de categorias do produto",
          imgPath: "/assets/loja-virtual/tela-categorias-produto.webp",
        },
        {
          label: "Tela de pedidos",
          imgPath: "/assets/loja-virtual/tela-pedidos.webp",
        },
        {
          label: "Tela de detalhes do pedido",
          imgPath: "/assets/loja-virtual/detalhes-pedido.webp",
        },
        {
          label: "Tela de configurações gerais",
          imgPath: "/assets/loja-virtual/tela-configuracoes-geral.webp",
        },
        {
          label: "Tela de clientes",
          imgPath: "/assets/loja-virtual/tela-clientes.webp",
        },
        {
          label: "Tela de configurações de meios de pagamento",
          imgPath: "/assets/loja-virtual/tela-pagamentos.webp",
        },
        {
          label: "Tela de relatórios",
          imgPath: "/assets/loja-virtual/tela-relatorios.webp",
        },
        {
          label: "Tela de formulários",
          imgPath: "/assets/loja-virtual/formulario-newsletter.webp",
        },
        {
          label: "Email newsletter",
          imgPath: "/assets/loja-virtual/email-newsletter.webp",
        },
      ],
      formulario: "",
      features: [
        {
          icon: <PlusCircle className="w-8 h-8 text-primary" />,
          title: "Cadastro Fácil",
          description:
            "Adicione novos produtos com apenas alguns cliques, sem complicações.",
        },
        {
          icon: <ClipboardList className="w-8 h-8 text-primary" />,
          title: "Gestão Simplificada",
          description:
            "Controle seus pedidos de forma eficiente e acompanhe o desempenho da loja.",
        },
        {
          icon: <CreditCard className="w-8 h-8 text-primary" />,
          title: "Pagamentos Integrados",
          description:
            "Ofereça aos seus clientes as opções de pagamento mais populares, como pix, cartão e transferência.",
        },
        {
          icon: <Truck className="w-8 h-8 text-primary" />,
          title: "Controle de Entregas",
          description:
            "Acompanhe o status de envio de cada pedido e informe seus clientes em tempo real.",
        },
        {
          icon: <Search className="w-8 h-8 text-primary" />,
          title: "Busca e Filtros",
          description:
            "Facilite a navegação de clientes com filtros por categoria, preço e disponibilidade.",
        },
        {
          icon: <ShieldCheck className="w-8 h-8 text-primary" />,
          title: "Segurança e Confiabilidade",
          description:
            "Transações seguras e proteção de dados para clientes e lojista.",
        },
      ],
      includedFeatures: [
        "Loja virtual pronta para uso, totalmente funcional",
        "Cadastro rápido e intuitivo de produtos",
        "Gestão completa de pedidos e estoque",
        "Pagamentos integrados via pix, cartão e transferência bancária",
        "Controle de entregas e acompanhamento em tempo real",
        "Layout moderno, responsivo e personalizável",
      ],
      beneficiosDescription: `
               Gerencie sua loja virtual de forma simples e eficiente: cadastre produtos rapidamente, controle pedidos com facilidade e ofereça pagamentos seguros e integrados para seus clientes.
            `,
    },
    {
      productId: "#L09",
      platform: "woocommerce",
      titlePage:
        "Loja Virtual em WordPress com WooCommerce de Roupas e Produtos de Ciclismo",
      titleCard:
        "Loja Virtual em WordPress com WooCommerce de Roupas e Produtos de Ciclismo",
      nicho: "Ciclismo & Moda Esportiva",
      image: "/assets/loja-virtual/ride-the-beat.webp",
      link: "https://ridethebeat.com.br/",
      caseBadge: "Projeto Real / Cliente",
      clientName: "Ride the Beat",
      caseCtaLabel: "Visitar Loja",
      caseDemoCtaLabel: "Visitar Loja",
      price: "",
      priceSale: "",
      exibirFidelidade: false,
      cardDescription: `
        <strong>Case real: Ride the Beat.</strong> A cliente já vendia pelo Instagram e precisava de uma loja própria para deixar de fechar pedido no direct. Desenvolvemos a loja em <strong>WordPress com WooCommerce</strong>, com checkout integrado ao <strong>Mercado Pago</strong> e hospedagem gerenciada pela Sistemas Flex.
        <br /><br />
        <strong>Prazo:</strong> de 7 a 15 dias úteis.
      `,
      description: `
        <p>
          <strong>Desafio:</strong> a Ride the Beat vendia roupas e produtos de ciclismo pelo Instagram, com cada venda dependendo de conversa no direct para combinar preço, frete e pagamento. Faltava um endereço próprio na internet onde o cliente conseguisse ver o catálogo, escolher tamanho e concluir a compra sozinho, a qualquer hora.
        </p>
        <br />
        <p>
          <strong>O que fizemos:</strong> desenvolvemos a loja em <strong>WordPress com WooCommerce</strong>, com layout criado a partir da identidade da marca e catálogo estruturado por categorias de vestuário e acessórios de ciclismo, já preparado para variações de tamanho e cor. Entregamos toda a jornada de compra (home, categoria, página de produto, busca, carrinho, checkout, minha conta e pedido confirmado), as páginas institucionais (Sobre Nós, Política de Privacidade, Termos e Condições, Trocas e Devoluções, Prazos e Envios), o painel administrativo e o cadastro do <strong>Perfil de Empresa no Google</strong>.
        </p>
        <br />
        <p>
          <strong>Diferencial técnico:</strong> checkout integrado ao gateway <strong>Mercado Pago</strong> (pix, cartão e boleto) e loja publicada em <strong>domínio próprio</strong> (ridethebeat.com.br), com hospedagem gerenciada na infraestrutura da Sistemas Flex: atualizações de segurança, monitoramento de disponibilidade, backup semanal e suporte orientativo sobre o painel. A cliente recebeu também um manual de uso para cadastrar produtos e ajustar configurações com autonomia.
        </p>
      `,
      video: "",
      planosValues: [
        {
          type: "Invista no Crescimento do Seu Negócio com uma Loja Virtual Profissional 🚀",
          value: "",
          valueInstallments: "Parcelamos até 12x no cartão de crédito",
          info: `
            <p><strong>Inclui:</strong></p>
            <ul>
              <li>Criação de loja virtual personalizada em WordPress com WooCommerce</li>
              <li>Catálogo estruturado por categorias, com variações de tamanho e cor</li>
              <li>Checkout integrado ao gateway de pagamento Mercado Pago</li>
              <li>Páginas institucionais completas (Sobre Nós, Política de Privacidade, Termos e Condições, Trocas e Devoluções, Prazos e Envios)</li>
              <li>Configuração de domínio próprio</li>
              <li>Cadastro do Perfil de Empresa no Google</li>
              <li>Painel administrativo em WordPress (totalmente gerenciável)</li>
              <li>Hospedagem gerenciada com atualizações de segurança, monitoramento e backup semanal</li>
              <li>Suporte técnico durante a implementação</li>
              <li>Treinamento básico para gestão da loja</li>
            </ul>
            <p><strong>Pronto para dar o próximo passo?</strong></p>
            <p>📞 <strong>Entre em contato agora pelo WhatsApp</strong> e agende uma reunião por vídeo!</p>
            <br />
            <a href="https://api.whatsapp.com/send?phone=5511964914546" target="_blank" class="CTA">👉 Vamos conversar</a>

          `,
        },
      ],
      page: "/lojas-virtuais/ride-the-beat",
      filter: "lojas-virtuais",
      carousel: false,
      imagesCarousel: [
        {
          label: "Configurações do Produto - Listagem",
          imgPath: "/assets/loja-virtual/configuracoes-produto.webp",
        },
        {
          label: "Tela de configurações do produto",
          imgPath: "/assets/loja-virtual/tela-produtos.webp",
        },
        {
          label: "Tela de categorias do produto",
          imgPath: "/assets/loja-virtual/tela-categorias-produto.webp",
        },
        {
          label: "Tela de pedidos",
          imgPath: "/assets/loja-virtual/tela-pedidos.webp",
        },
        {
          label: "Tela de detalhes do pedido",
          imgPath: "/assets/loja-virtual/detalhes-pedido.webp",
        },
        {
          label: "Tela de configurações gerais",
          imgPath: "/assets/loja-virtual/tela-configuracoes-geral.webp",
        },
        {
          label: "Tela de clientes",
          imgPath: "/assets/loja-virtual/tela-clientes.webp",
        },
        {
          label: "Tela de configurações de meios de pagamento",
          imgPath: "/assets/loja-virtual/tela-pagamentos.webp",
        },
        {
          label: "Tela de relatórios",
          imgPath: "/assets/loja-virtual/tela-relatorios.webp",
        },
        {
          label: "Tela de formulários",
          imgPath: "/assets/loja-virtual/formulario-newsletter.webp",
        },
        {
          label: "Email newsletter",
          imgPath: "/assets/loja-virtual/email-newsletter.webp",
        },
      ],
      formulario: "",
      features: [
        {
          icon: <PlusCircle className="w-8 h-8 text-primary" />,
          title: "Cadastro Fácil",
          description:
            "Adicione novos produtos com apenas alguns cliques, sem complicações.",
        },
        {
          icon: <ClipboardList className="w-8 h-8 text-primary" />,
          title: "Gestão Simplificada",
          description:
            "Controle seus pedidos de forma eficiente e acompanhe o desempenho da loja.",
        },
        {
          icon: <CreditCard className="w-8 h-8 text-primary" />,
          title: "Pagamentos Integrados",
          description:
            "Ofereça aos seus clientes as opções de pagamento mais populares, como pix, cartão e transferência.",
        },
        {
          icon: <Truck className="w-8 h-8 text-primary" />,
          title: "Controle de Entregas",
          description:
            "Acompanhe o status de envio de cada pedido e informe seus clientes em tempo real.",
        },
        {
          icon: <Search className="w-8 h-8 text-primary" />,
          title: "Busca e Filtros",
          description:
            "Facilite a navegação de clientes com filtros por categoria, preço e disponibilidade.",
        },
        {
          icon: <ShieldCheck className="w-8 h-8 text-primary" />,
          title: "Segurança e Confiabilidade",
          description:
            "Transações seguras e proteção de dados para clientes e lojista.",
        },
      ],
      includedFeatures: [
        "Loja virtual pronta para uso, totalmente funcional",
        "Cadastro rápido e intuitivo de produtos",
        "Gestão completa de pedidos e estoque",
        "Pagamentos integrados via pix, cartão e transferência bancária",
        "Controle de entregas e acompanhamento em tempo real",
        "Layout moderno, responsivo e personalizável",
      ],
      beneficiosDescription: `
               Gerencie sua loja virtual de forma simples e eficiente: cadastre produtos rapidamente, controle pedidos com facilidade e ofereça pagamentos seguros e integrados para seus clientes.
            `,
    },
    {
      productId: "#L10",
      platform: "nuvemshop",
      titlePage:
        "Loja Virtual na Nuvemshop de Armadilhas e Equipamentos para Controle de Javalis",
      titleCard:
        "Loja Virtual na Nuvemshop de Armadilhas e Equipamentos para Controle de Javalis",
      nicho: "Manejo Ambiental & Equipamentos",
      image: "/assets/loja-virtual/javali-40.webp",
      link: "https://www.javali40.com.br/",
      caseBadge: "Projeto Real / Cliente",
      clientName: "Javali 4.0",
      caseCtaLabel: "Visitar Loja",
      caseDemoCtaLabel: "Visitar Loja",
      price: "",
      priceSale: "",
      exibirFidelidade: false,
      cardDescription: `
        <strong>Case real: Javali 4.0.</strong> Um produto técnico, de alto valor e venda consultiva, que até então dependia do WhatsApp. Criamos a loja na <strong>Nuvemshop</strong> com catálogo por linha de produto e a reorganização dos domínios da marca.
        <!-- TODO: reativar quando a seção de depoimentos sob medida for entregue:
        Criamos a loja na <strong>Nuvemshop</strong> e desenvolvemos uma <strong>seção de depoimentos sob medida</strong>, com vídeos das capturas reais, alimentada por planilha e sem mensalidade de aplicativo. -->
        <br /><br />
        <strong>Prazo:</strong> de 7 a 15 dias úteis.
      `,
      description: `
        <p>
          <strong>Desafio:</strong> a Javali 4.0, marca da Mão na Mata, vende armadilhas de rede, armadilhas de curral e câmeras de trilha para controle de javalis, um produto técnico, de ticket alto e decisão consultiva, que até então era negociado por WhatsApp e apoiado apenas em um site institucional. Era preciso construir um canal de venda próprio e, principalmente, provar resultado: quem compra quer ver a armadilha funcionando no campo antes de decidir.
        </p>
        <br />
        <p>
          <strong>O que fizemos:</strong> desenvolvemos a loja na plataforma <strong>Nuvemshop</strong> no domínio javali40.com.br, com catálogo estruturado por linha de produto (armadilhas de rede, armadilhas de curral e câmeras de monitoramento) e variações de cada modelo. Entregamos a jornada completa de compra (home com seções estratégicas e botão flutuante de WhatsApp, categoria, produto, busca, carrinho, checkout e minha conta), as páginas institucionais, o cadastro do <strong>Perfil de Empresa no Google</strong> e a orientação de uso do painel para cadastro de produtos, categorias, meios de pagamento e de envio.
        </p>
        <br />
        <p>
          <strong>Diferencial técnico:</strong>
          <!-- TODO: reativar quando a seção de depoimentos sob medida for entregue:
          criamos uma <strong>seção de depoimentos desenvolvida sob medida</strong>, e não via aplicativo de assinatura: cada card exibe o vídeo ou a foto da captura, avaliação em estrelas, nome do cliente e a legenda com cidade e estado, com página dedicada a todos os depoimentos. O cadastro é feito por uma planilha do Google na conta do próprio cliente, sem limite de depoimentos e <strong>sem mensalidade</strong>. Também -->
          entregamos uma seção institucional editável pelo painel e conduzimos a <strong>reorganização dos domínios</strong>: o conteúdo institucional migrado para maonamata.com.br e o javali40.com.br apontado para a loja, com apontamento de DNS, SSL e preservação das contas de e-mail corporativo.
        </p>
      `,
      video: "",
      planosValues: [
        {
          type: "Invista no Crescimento do Seu Negócio com uma Loja Virtual Profissional 🚀",
          value: "",
          valueInstallments: "Parcelamos até 12x no cartão de crédito",
          info: `
            <p><strong>Inclui:</strong></p>
            <ul>
              <li>Criação de loja virtual personalizada na Nuvemshop</li>
              <li>Catálogo estruturado por linha de produto, com variações de cada modelo</li>
              <li>Home com seções estratégicas de conteúdo e botão flutuante de WhatsApp</li>
              <!-- TODO: reativar quando a seção de depoimentos sob medida for entregue:
              <li>Seção de depoimentos sob medida, com vídeo, estrelas e legenda de cidade/estado, cadastrada por planilha e sem mensalidade</li> -->
              <li>Páginas institucionais completas (Sobre Nós, Política de Privacidade, Termos e Condições, Trocas e Devoluções, Prazos e Envios)</li>
              <li>Configuração e apontamento de domínio</li>
              <li>Cadastro do Perfil de Empresa no Google</li>
              <li>Recursos e usuários conforme o plano Nuvemshop escolhido.</li>
              <li>Painel administrativo Nuvemshop (totalmente gerenciável)</li>
              <li>Suporte técnico durante a implementação</li>
              <li>Orientação sobre cadastro de produtos, categorias, meios de pagamento e de envio</li>
            </ul>
            <p><strong>Pronto para dar o próximo passo?</strong></p>
            <p>📞 <strong>Entre em contato agora pelo WhatsApp</strong> e agende uma reunião por vídeo!</p>
            <br />
            <a href="https://api.whatsapp.com/send?phone=5511964914546" target="_blank" class="CTA">👉 Vamos conversar</a>

          `,
        },
      ],
      page: "/lojas-virtuais/javali-40",
      filter: "lojas-virtuais",
      carousel: false,
      imagesCarousel: [
        {
          label: "Configurações do Produto - Listagem",
          imgPath: "/assets/loja-virtual/configuracoes-produto.webp",
        },
        {
          label: "Tela de configurações do produto",
          imgPath: "/assets/loja-virtual/tela-produtos.webp",
        },
        {
          label: "Tela de categorias do produto",
          imgPath: "/assets/loja-virtual/tela-categorias-produto.webp",
        },
        {
          label: "Tela de pedidos",
          imgPath: "/assets/loja-virtual/tela-pedidos.webp",
        },
        {
          label: "Tela de detalhes do pedido",
          imgPath: "/assets/loja-virtual/detalhes-pedido.webp",
        },
        {
          label: "Tela de configurações gerais",
          imgPath: "/assets/loja-virtual/tela-configuracoes-geral.webp",
        },
        {
          label: "Tela de clientes",
          imgPath: "/assets/loja-virtual/tela-clientes.webp",
        },
        {
          label: "Tela de configurações de meios de pagamento",
          imgPath: "/assets/loja-virtual/tela-pagamentos.webp",
        },
        {
          label: "Tela de relatórios",
          imgPath: "/assets/loja-virtual/tela-relatorios.webp",
        },
        {
          label: "Tela de formulários",
          imgPath: "/assets/loja-virtual/formulario-newsletter.webp",
        },
        {
          label: "Email newsletter",
          imgPath: "/assets/loja-virtual/email-newsletter.webp",
        },
      ],
      formulario: "",
      features: [
        {
          icon: <PlusCircle className="w-8 h-8 text-primary" />,
          title: "Cadastro Fácil",
          description:
            "Adicione novos produtos com apenas alguns cliques, sem complicações.",
        },
        {
          icon: <ClipboardList className="w-8 h-8 text-primary" />,
          title: "Gestão Simplificada",
          description:
            "Controle seus pedidos de forma eficiente e acompanhe o desempenho da loja.",
        },
        {
          icon: <CreditCard className="w-8 h-8 text-primary" />,
          title: "Pagamentos Integrados",
          description:
            "Ofereça aos seus clientes as opções de pagamento mais populares, como pix, cartão e transferência.",
        },
        {
          icon: <Truck className="w-8 h-8 text-primary" />,
          title: "Controle de Entregas",
          description:
            "Acompanhe o status de envio de cada pedido e informe seus clientes em tempo real.",
        },
        {
          icon: <Search className="w-8 h-8 text-primary" />,
          title: "Busca e Filtros",
          description:
            "Facilite a navegação de clientes com filtros por categoria, preço e disponibilidade.",
        },
        {
          icon: <ShieldCheck className="w-8 h-8 text-primary" />,
          title: "Segurança e Confiabilidade",
          description:
            "Transações seguras e proteção de dados para clientes e lojista.",
        },
      ],
      includedFeatures: [
        "Loja virtual pronta para uso, totalmente funcional",
        "Cadastro rápido e intuitivo de produtos",
        "Gestão completa de pedidos e estoque",
        "Pagamentos integrados via pix, cartão e transferência bancária",
        "Controle de entregas e acompanhamento em tempo real",
        "Layout moderno, responsivo e personalizável",
      ],
      beneficiosDescription: `
               Gerencie sua loja virtual de forma simples e eficiente: cadastre produtos rapidamente, controle pedidos com facilidade e ofereça pagamentos seguros e integrados para seus clientes.
            `,
    },
    {
      productId: "#L11",
      platform: "woocommerce",
      titlePage:
        "Loja Virtual em WordPress com WooCommerce de Gravatas e Artigos Sociais",
      titleCard:
        "Loja Virtual em WordPress com WooCommerce de Gravatas e Artigos Sociais",
      nicho: "Moda Masculina & Artigos Sociais",
      image: "/assets/loja-virtual/via-ds-sartoria.webp",
      link: "http://viadssartoria.com.br/",
      caseBadge: "Projeto Real / Cliente",
      clientName: "VIA DS SARTORIA",
      caseCtaLabel: "Visitar Loja",
      caseDemoCtaLabel: "Visitar Loja",
      price: "",
      priceSale: "",
      exibirFidelidade: false,
      cardDescription: `
        <strong>Case real: VIA DS SARTORIA.</strong> O cliente tinha começado a montar a loja sozinho e parou no meio do caminho. Assumimos o projeto em <strong>WordPress com WooCommerce</strong>, com uma home enxuta que valoriza o produto, checkout no <strong>Mercado Pago</strong> e frete calculado pelo <strong>Melhor Envio</strong>.
        <br /><br />
        <strong>Prazo:</strong> de 7 a 15 dias úteis.
      `,
      description: `
        <p>
          <strong>Desafio:</strong> depois de alguns anos fora, o lojista da VIA DS SARTORIA estava retomando as vendas com uma loja de artigos sociais, começando por gravatas e meias. Ele chegou a iniciar a montagem por conta própria, subiu o logo e começou a escolher o tema, mas parou por falta de tempo e de domínio técnico. O pedido era claro: uma loja feita por quem faz isso profissionalmente e uma <strong>página inicial limpa</strong>, sem poluição visual.
        </p>
        <br />
        <p>
          <strong>O que fizemos:</strong> desenvolvemos a loja em <strong>WordPress com WooCommerce</strong>, seguindo a referência de layout trazida pelo cliente e priorizando uma home de poucas seções, com respiro e foco na vitrine. O catálogo foi estruturado por categoria de artigo social, com variações de cor e estampa, e entregamos a jornada completa de compra (home, categoria, produto, busca, carrinho, checkout, minha conta e pedido confirmado), as páginas institucionais, o painel administrativo e o cadastro do <strong>Perfil de Empresa no Google</strong>.
        </p>
        <br />
        <p>
          <strong>Diferencial técnico:</strong> checkout integrado ao gateway <strong>Mercado Pago</strong> (pix, cartão e boleto) e cálculo de frete pelo <strong>Melhor Envio</strong>, com as transportadoras contratadas pelo lojista já configuradas na loja. A publicação foi feita em domínio próprio, com conta de e-mail da loja, e a operação roda em hospedagem gerenciada na infraestrutura da Sistemas Flex: atualizações de segurança, monitoramento de disponibilidade, backup semanal e suporte orientativo sobre o painel.
        </p>
      `,
      video: "",
      planosValues: [
        {
          type: "Invista no Crescimento do Seu Negócio com uma Loja Virtual Profissional 🚀",
          value: "",
          valueInstallments: "Parcelamos até 12x no cartão de crédito",
          info: `
            <p><strong>Inclui:</strong></p>
            <ul>
              <li>Criação de loja virtual personalizada em WordPress com WooCommerce</li>
              <li>Layout enxuto, construído a partir da referência e da identidade da marca</li>
              <li>Catálogo estruturado por categoria, com variações de cor e estampa</li>
              <li>Checkout integrado ao gateway de pagamento Mercado Pago</li>
              <li>Cálculo de frete integrado ao Melhor Envio</li>
              <li>Páginas institucionais completas (Sobre Nós, Política de Privacidade, Termos e Condições, Trocas e Devoluções, Prazos e Envios)</li>
              <li>Configuração de domínio próprio e conta de e-mail da loja</li>
              <li>Cadastro do Perfil de Empresa no Google</li>
              <li>Painel administrativo em WordPress (totalmente gerenciável)</li>
              <li>Hospedagem gerenciada com atualizações de segurança, monitoramento e backup semanal</li>
              <li>Suporte técnico durante a implementação</li>
              <li>Treinamento básico para gestão da loja</li>
            </ul>
            <p><strong>Pronto para dar o próximo passo?</strong></p>
            <p>📞 <strong>Entre em contato agora pelo WhatsApp</strong> e agende uma reunião por vídeo!</p>
            <br />
            <a href="https://api.whatsapp.com/send?phone=5511964914546" target="_blank" class="CTA">👉 Vamos conversar</a>

          `,
        },
      ],
      page: "/lojas-virtuais/via-ds-sartoria",
      filter: "lojas-virtuais",
      carousel: false,
      imagesCarousel: [
        {
          label: "Configurações do Produto - Listagem",
          imgPath: "/assets/loja-virtual/configuracoes-produto.webp",
        },
        {
          label: "Tela de configurações do produto",
          imgPath: "/assets/loja-virtual/tela-produtos.webp",
        },
        {
          label: "Tela de categorias do produto",
          imgPath: "/assets/loja-virtual/tela-categorias-produto.webp",
        },
        {
          label: "Tela de pedidos",
          imgPath: "/assets/loja-virtual/tela-pedidos.webp",
        },
        {
          label: "Tela de detalhes do pedido",
          imgPath: "/assets/loja-virtual/detalhes-pedido.webp",
        },
        {
          label: "Tela de configurações gerais",
          imgPath: "/assets/loja-virtual/tela-configuracoes-geral.webp",
        },
        {
          label: "Tela de clientes",
          imgPath: "/assets/loja-virtual/tela-clientes.webp",
        },
        {
          label: "Tela de configurações de meios de pagamento",
          imgPath: "/assets/loja-virtual/tela-pagamentos.webp",
        },
        {
          label: "Tela de relatórios",
          imgPath: "/assets/loja-virtual/tela-relatorios.webp",
        },
        {
          label: "Tela de formulários",
          imgPath: "/assets/loja-virtual/formulario-newsletter.webp",
        },
        {
          label: "Email newsletter",
          imgPath: "/assets/loja-virtual/email-newsletter.webp",
        },
      ],
      formulario: "",
      features: [
        {
          icon: <PlusCircle className="w-8 h-8 text-primary" />,
          title: "Cadastro Fácil",
          description:
            "Adicione novos produtos com apenas alguns cliques, sem complicações.",
        },
        {
          icon: <ClipboardList className="w-8 h-8 text-primary" />,
          title: "Gestão Simplificada",
          description:
            "Controle seus pedidos de forma eficiente e acompanhe o desempenho da loja.",
        },
        {
          icon: <CreditCard className="w-8 h-8 text-primary" />,
          title: "Pagamentos Integrados",
          description:
            "Ofereça aos seus clientes as opções de pagamento mais populares, como pix, cartão e transferência.",
        },
        {
          icon: <Truck className="w-8 h-8 text-primary" />,
          title: "Controle de Entregas",
          description:
            "Acompanhe o status de envio de cada pedido e informe seus clientes em tempo real.",
        },
        {
          icon: <Search className="w-8 h-8 text-primary" />,
          title: "Busca e Filtros",
          description:
            "Facilite a navegação de clientes com filtros por categoria, preço e disponibilidade.",
        },
        {
          icon: <ShieldCheck className="w-8 h-8 text-primary" />,
          title: "Segurança e Confiabilidade",
          description:
            "Transações seguras e proteção de dados para clientes e lojista.",
        },
      ],
      includedFeatures: [
        "Loja virtual pronta para uso, totalmente funcional",
        "Cadastro rápido e intuitivo de produtos",
        "Gestão completa de pedidos e estoque",
        "Pagamentos integrados via pix, cartão e transferência bancária",
        "Controle de entregas e acompanhamento em tempo real",
        "Layout moderno, responsivo e personalizável",
      ],
      beneficiosDescription: `
               Gerencie sua loja virtual de forma simples e eficiente: cadastre produtos rapidamente, controle pedidos com facilidade e ofereça pagamentos seguros e integrados para seus clientes.
            `,
    },
    {
      productId: "#L12",
      platform: "nuvemshop",
      titlePage:
        "Migração de Loja Virtual de Moda Feminina da Irroba para a Nuvemshop",
      titleCard:
        "Migração de Loja Virtual de Moda Feminina da Irroba para a Nuvemshop",
      nicho: "Moda",
      image: "/assets/loja-virtual/duotti.webp",
      link: "https://duotti.com.br/",
      caseBadge: "Projeto Real / Cliente",
      clientName: "DUOTTI",
      caseCtaLabel: "Visitar Loja",
      caseDemoCtaLabel: "Visitar Loja",
      price: "",
      priceSale: "",
      exibirFidelidade: false,
      cardDescription: `
        <strong>Case real: DUOTTI.</strong> Marca de moda feminina com foco em alfaiataria, loja física em Volta Redonda (RJ) e vendas fortes no Instagram. Migramos a loja da <strong>Irroba</strong> para a <strong>Nuvemshop</strong> com 933 produtos, mais de 12 mil clientes e redirecionamentos 301 para preservar o SEO.
        <br /><br />
        <strong>Prazo:</strong> até 15 dias úteis.
      `,
      description: `
        <p>
          <strong>Desafio:</strong> a DUOTTI, marca de moda feminina com foco em alfaiataria e peças versáteis que vão do escritório ao evento social, vendia pela plataforma Irroba e queria migrar para a <strong>Nuvemshop</strong> em busca de mais conversão. A loja já tinha catálogo grande, base de clientes construída ao longo dos anos, tráfego pago rodando no Meta Ads e um domínio indexado no Google: a migração não podia perder vendas, clientes nem posicionamento.
        </p>
        <br />
        <p>
          <strong>O que fizemos:</strong> conduzimos a migração completa para a Nuvemshop. Transferimos os <strong>933 produtos</strong> com suas variações e importamos <strong>12.791 clientes</strong>, com tratamento prévio da base: padronização dos telefones, correção de números fora do padrão e remoção de registros inválidos que travariam a importação. Configuramos o novo layout a partir da identidade da marca, com banners rotativos no topo e seção de imagem e texto para os produtos mais vendidos, além do checkout com <strong>Nuvem Pago</strong> (Pix com desconto e parcelamento em até 12x) e frete via <strong>Nuvem Envio, Melhor Envio, Jadlog e Correios</strong>.
        </p>
        <br />
        <p>
          <strong>Diferencial técnico:</strong> mapeamos as URLs antigas da Irroba e montamos o <strong>DE/PARA de redirecionamentos 301</strong>, para que links indexados no Google, anúncios e posts antigos continuassem levando às páginas certas. Também fizemos o apontamento de DNS do domínio duotti.com.br e a integração com o <strong>Meta Business</strong> (catálogo e Pixel) e o <strong>Google Merchant Center</strong>, deixando o catálogo pronto para anúncios e Google Shopping.
        </p>
      `,
      video: "",
      planosValues: [
        {
          type: "Invista no Crescimento do Seu Negócio com uma Loja Virtual Profissional 🚀",
          value: "",
          valueInstallments: "Parcelamos até 12x no cartão de crédito",
          info: `
            <p><strong>Inclui:</strong></p>
            <ul>
              <li>Migração completa de plataforma para a Nuvemshop</li>
              <li>Migração de produtos com variações e importação da base de clientes</li>
              <li>Tratamento e padronização dos dados antes da importação</li>
              <li>Layout configurado a partir da identidade da marca, com banners rotativos e seção de produtos destaque</li>
              <li>Redirecionamentos 301 das URLs antigas para preservar o SEO</li>
              <li>Configuração e apontamento de domínio</li>
              <li>Meios de pagamento e de envio configurados</li>
              <li>Integração com Meta Business (catálogo e Pixel) e Google Merchant Center</li>
              <li>Instalação e configuração de aplicativos da loja Nuvemshop</li>
              <li>Painel administrativo Nuvemshop (totalmente gerenciável)</li>
              <li>Suporte técnico durante a implementação e manual operacional do painel</li>
            </ul>
            <p><strong>Pronto para dar o próximo passo?</strong></p>
            <p>📞 <strong>Entre em contato agora pelo WhatsApp</strong> e agende uma reunião por vídeo!</p>
            <br />
            <a href="https://api.whatsapp.com/send?phone=5511964914546" target="_blank" class="CTA">👉 Vamos conversar</a>

          `,
        },
      ],
      page: "/lojas-virtuais/duotti",
      filter: "lojas-virtuais",
      carousel: false,
      imagesCarousel: [
        {
          label: "Configurações do Produto - Listagem",
          imgPath: "/assets/loja-virtual/configuracoes-produto.webp",
        },
        {
          label: "Tela de configurações do produto",
          imgPath: "/assets/loja-virtual/tela-produtos.webp",
        },
        {
          label: "Tela de categorias do produto",
          imgPath: "/assets/loja-virtual/tela-categorias-produto.webp",
        },
        {
          label: "Tela de pedidos",
          imgPath: "/assets/loja-virtual/tela-pedidos.webp",
        },
        {
          label: "Tela de detalhes do pedido",
          imgPath: "/assets/loja-virtual/detalhes-pedido.webp",
        },
        {
          label: "Tela de configurações gerais",
          imgPath: "/assets/loja-virtual/tela-configuracoes-geral.webp",
        },
        {
          label: "Tela de clientes",
          imgPath: "/assets/loja-virtual/tela-clientes.webp",
        },
        {
          label: "Tela de configurações de meios de pagamento",
          imgPath: "/assets/loja-virtual/tela-pagamentos.webp",
        },
        {
          label: "Tela de relatórios",
          imgPath: "/assets/loja-virtual/tela-relatorios.webp",
        },
        {
          label: "Tela de formulários",
          imgPath: "/assets/loja-virtual/formulario-newsletter.webp",
        },
        {
          label: "Email newsletter",
          imgPath: "/assets/loja-virtual/email-newsletter.webp",
        },
      ],
      formulario: "",
      features: [
        {
          icon: <PlusCircle className="w-8 h-8 text-primary" />,
          title: "Cadastro Fácil",
          description:
            "Adicione novos produtos com apenas alguns cliques, sem complicações.",
        },
        {
          icon: <ClipboardList className="w-8 h-8 text-primary" />,
          title: "Gestão Simplificada",
          description:
            "Controle seus pedidos de forma eficiente e acompanhe o desempenho da loja.",
        },
        {
          icon: <CreditCard className="w-8 h-8 text-primary" />,
          title: "Pagamentos Integrados",
          description:
            "Ofereça aos seus clientes as opções de pagamento mais populares, como pix, cartão e transferência.",
        },
        {
          icon: <Truck className="w-8 h-8 text-primary" />,
          title: "Controle de Entregas",
          description:
            "Acompanhe o status de envio de cada pedido e informe seus clientes em tempo real.",
        },
        {
          icon: <Search className="w-8 h-8 text-primary" />,
          title: "Busca e Filtros",
          description:
            "Facilite a navegação de clientes com filtros por categoria, preço e disponibilidade.",
        },
        {
          icon: <ShieldCheck className="w-8 h-8 text-primary" />,
          title: "Segurança e Confiabilidade",
          description:
            "Transações seguras e proteção de dados para clientes e lojista.",
        },
      ],
      includedFeatures: [
        "Loja virtual pronta para uso, totalmente funcional",
        "Cadastro rápido e intuitivo de produtos",
        "Gestão completa de pedidos e estoque",
        "Pagamentos integrados via pix, cartão e transferência bancária",
        "Controle de entregas e acompanhamento em tempo real",
        "Layout moderno, responsivo e personalizável",
      ],
      beneficiosDescription: `
               Gerencie sua loja virtual de forma simples e eficiente: cadastre produtos rapidamente, controle pedidos com facilidade e ofereça pagamentos seguros e integrados para seus clientes.
            `,
    },
    {
      productId: "#L13",
      platform: "nuvemshop",
      titlePage: "Loja Virtual de Camisetas Autorais na Nuvemshop",
      titleCard: "Loja Virtual de Camisetas Autorais na Nuvemshop",
      nicho: "Moda",
      image: "/assets/loja-virtual/saint-luce.webp",
      link: "https://saintluce.com.br/",
      caseBadge: "Projeto Real / Cliente",
      clientName: "Saint Luce",
      caseCtaLabel: "Visitar Loja",
      caseDemoCtaLabel: "Visitar Loja",
      price: "",
      priceSale: "",
      exibirFidelidade: false,
      cardDescription: `
        <strong>Case real: Saint Luce.</strong> Marca nova de camisetas com estampas autorais inspiradas em viagens e no estilo de vida europeu. O lojista não tinha tempo nem experiência para montar a loja: entregamos tudo pronto na <strong>Nuvemshop</strong>, do registro do domínio ao checkout.
        <br /><br />
        <strong>Prazo:</strong> até 7 dias úteis.
      `,
      description: `
        <p>
          <strong>Desafio:</strong> a Saint Luce estava nascendo, com a primeira coleção de três camisetas e apenas a logomarca em mãos. O lojista queria vender pela <strong>Nuvemshop</strong>, mas não tinha tempo nem domínio técnico para montar a loja sozinho. Por ser uma marca com identidade própria, voltada a um público que gosta de viagens e do estilo de vida europeu, a loja precisava transmitir esse posicionamento desde o primeiro acesso.
        </p>
        <br />
        <p>
          <strong>O que fizemos:</strong> registramos o domínio saintluce.com.br e desenvolvemos a loja a partir da identidade visual da marca, com a paleta em azul-marinho, banners rotativos para a <strong>Coleção Bella Vita</strong> e uma seção na página inicial contando a história da marca. Cadastramos os produtos com variações de tamanho, estoque por grade e tabela de medidas, e entregamos a jornada completa de compra (home, categoria, produto, busca, carrinho, checkout e minha conta), as páginas institucionais e um manual simplificado de uso do painel.
        </p>
        <br />
        <p>
          <strong>Diferencial técnico:</strong> configuramos o <strong>Nuvem Pago</strong> com Pix, boleto e cartão em até 3x sem juros, e o frete com entrega para todo o Brasil. A home conta com botão flutuante de WhatsApp e uma seção de feed do Instagram integrada pelo serviço próprio da Sistemas Flex, que acompanha a renovação do acesso para o feed não sair do ar. A loja foi desenvolvida em ambiente de testes e transferida para a conta do lojista já pronta para vender.
        </p>
      `,
      video: "",
      planosValues: [
        {
          type: "Invista no Crescimento do Seu Negócio com uma Loja Virtual Profissional 🚀",
          value: "",
          valueInstallments: "Parcelamos até 12x no cartão de crédito",
          info: `
            <p><strong>Inclui:</strong></p>
            <ul>
              <li>Criação de loja virtual personalizada na Nuvemshop</li>
              <li>Layout construído a partir da identidade visual da marca</li>
              <li>Banners rotativos e seção sobre a marca na página inicial</li>
              <li>Cadastro dos primeiros produtos com variações de tamanho, estoque e tabela de medidas</li>
              <li>Botão flutuante de WhatsApp e seção de feed do Instagram</li>
              <li>Páginas institucionais completas (Sobre Nós, Política de Privacidade, Termos e Condições, Trocas e Devoluções, Prazos e Envios)</li>
              <li>Registro e configuração de domínio próprio</li>
              <li>Meios de pagamento e de envio configurados</li>
              <li>Painel administrativo Nuvemshop (totalmente gerenciável)</li>
              <li>Manual simplificado de uso do painel</li>
              <li>Suporte técnico durante a implementação</li>
            </ul>
            <p><strong>Pronto para dar o próximo passo?</strong></p>
            <p>📞 <strong>Entre em contato agora pelo WhatsApp</strong> e agende uma reunião por vídeo!</p>
            <br />
            <a href="https://api.whatsapp.com/send?phone=5511964914546" target="_blank" class="CTA">👉 Vamos conversar</a>

          `,
        },
      ],
      page: "/lojas-virtuais/saint-luce",
      filter: "lojas-virtuais",
      carousel: false,
      imagesCarousel: [
        {
          label: "Configurações do Produto - Listagem",
          imgPath: "/assets/loja-virtual/configuracoes-produto.webp",
        },
        {
          label: "Tela de configurações do produto",
          imgPath: "/assets/loja-virtual/tela-produtos.webp",
        },
        {
          label: "Tela de categorias do produto",
          imgPath: "/assets/loja-virtual/tela-categorias-produto.webp",
        },
        {
          label: "Tela de pedidos",
          imgPath: "/assets/loja-virtual/tela-pedidos.webp",
        },
        {
          label: "Tela de detalhes do pedido",
          imgPath: "/assets/loja-virtual/detalhes-pedido.webp",
        },
        {
          label: "Tela de configurações gerais",
          imgPath: "/assets/loja-virtual/tela-configuracoes-geral.webp",
        },
        {
          label: "Tela de clientes",
          imgPath: "/assets/loja-virtual/tela-clientes.webp",
        },
        {
          label: "Tela de configurações de meios de pagamento",
          imgPath: "/assets/loja-virtual/tela-pagamentos.webp",
        },
        {
          label: "Tela de relatórios",
          imgPath: "/assets/loja-virtual/tela-relatorios.webp",
        },
        {
          label: "Tela de formulários",
          imgPath: "/assets/loja-virtual/formulario-newsletter.webp",
        },
        {
          label: "Email newsletter",
          imgPath: "/assets/loja-virtual/email-newsletter.webp",
        },
      ],
      formulario: "",
      features: [
        {
          icon: <PlusCircle className="w-8 h-8 text-primary" />,
          title: "Cadastro Fácil",
          description:
            "Adicione novos produtos com apenas alguns cliques, sem complicações.",
        },
        {
          icon: <ClipboardList className="w-8 h-8 text-primary" />,
          title: "Gestão Simplificada",
          description:
            "Controle seus pedidos de forma eficiente e acompanhe o desempenho da loja.",
        },
        {
          icon: <CreditCard className="w-8 h-8 text-primary" />,
          title: "Pagamentos Integrados",
          description:
            "Ofereça aos seus clientes as opções de pagamento mais populares, como pix, cartão e transferência.",
        },
        {
          icon: <Truck className="w-8 h-8 text-primary" />,
          title: "Controle de Entregas",
          description:
            "Acompanhe o status de envio de cada pedido e informe seus clientes em tempo real.",
        },
        {
          icon: <Search className="w-8 h-8 text-primary" />,
          title: "Busca e Filtros",
          description:
            "Facilite a navegação de clientes com filtros por categoria, preço e disponibilidade.",
        },
        {
          icon: <ShieldCheck className="w-8 h-8 text-primary" />,
          title: "Segurança e Confiabilidade",
          description:
            "Transações seguras e proteção de dados para clientes e lojista.",
        },
      ],
      includedFeatures: [
        "Loja virtual pronta para uso, totalmente funcional",
        "Cadastro rápido e intuitivo de produtos",
        "Gestão completa de pedidos e estoque",
        "Pagamentos integrados via pix, cartão e transferência bancária",
        "Controle de entregas e acompanhamento em tempo real",
        "Layout moderno, responsivo e personalizável",
      ],
      beneficiosDescription: `
               Gerencie sua loja virtual de forma simples e eficiente: cadastre produtos rapidamente, controle pedidos com facilidade e ofereça pagamentos seguros e integrados para seus clientes.
            `,
    },
  ];

  return list;
};
